import React, {} from 'react';
import "./styles.scss";
import { VerseTable } from '../../components/tables/VerseTable/VerseTable';

export const Verses = () => {

  return (
    <div className='data-table'>
      <VerseTable />
    </div>
  );
};